import { type FC } from "react";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "../types/props";
import { getLinkFilters } from "./linkFilters";
import { type ExternalLinksFiltersEnum } from "features/Library/ExternalLinks/types/models";

export interface LinksFilterFormForPacksProps extends FilterFormPropsBase<ExternalLinksFiltersEnum> {}

const LinksFilterFormForPacks: FC<LinksFilterFormForPacksProps> = ({
  filterOptions,
  filter,
  onValidationChange,
  updateFilter,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getLinkFilters(false)}
    onValidationChange={onValidationChange}
  />
);

export default LinksFilterFormForPacks;
